const FromArr = [
  {
    modelvalue: "",
    title: "医院编号：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 180,
    height: 32,
    disabled: false,
    marginLeft: 35,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500,
  },
  {
    modelvalue: "",
    title: "医院名称：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 180,
    height: 32,
    disabled: false,
    marginLeft: 35,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500,
  },
  {
    modelvalue: "",
    title: "省份：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 192,
    height: 32,
    disabled: false,
    marginLeft: 70,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    event: 'Province'
  },
  {
    modelvalue: "",
    title: "城市：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 190,
    height: 32,
    disabled: false,
    marginLeft: 65,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    event: 'City'
  },
  {
    modelvalue: "",
    title: "区县：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 190,
    height: 32,
    disabled: false,
    marginLeft: 65,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    event: 'District'
  },
];
export default FromArr;
